import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

import { ReadingListDetails } from '®shared/reading-list/models';
import { idWithoutDotHtml } from '®shared/router';

import { ListResolverStoreService } from '../resolver-store';

@Injectable()
export class DraftListResolver implements Resolve<ReadingListDetails> {
  constructor(private listResolverStoreService: ListResolverStoreService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<ReadingListDetails> {
    const listId = idWithoutDotHtml(route.params['listId']);
    return this.listResolverStoreService.getDraftReadingList(listId);
  }
}
